import { GET_LOGS, GET_ONE_LOG, UPDATE_LOGS } from '../types';

const initialState = {
   list: [],
   single: null,
   pagination: {
      limit: 10,
      nextPage: null,
      totalPages: 1,
      currentPage: 1,
      hasNextPage: false,
      previousPage: null,
      totalProducts: 0,
      hasPreviousPage: false,
   },
};

const reducer = (state = initialState, action) => {
   const { type, payload } = action;

   switch (type) {
      case GET_LOGS:
         return { ...state, list: payload.data, pagination: payload.pagination, totalCount: payload.totalCount };

      case UPDATE_LOGS:
         return {
            ...state,
            list: state.list.map((item) => (item.id === payload.id ? payload : item)),
         };

      case GET_ONE_LOG:
         return { ...state, single: payload };

      default:
         return state;
   }
};

export default reducer;
